import { advanceTask } from './advanceTask'
import { IJob, registerJob, IJobType } from './jobs'
import { createConsumeCargoTask } from './taskConsumeCargo'
import { createTask_custom } from './taskCustom'
import { createTask_deliverCargo } from './taskDeliverCargo'
import { createFetchCargoTask } from './taskFetchCargo'
import { jobLogger } from './jobLogger-sidecar'

const jobType: IJobType = 'fill-battery'
export const register = () => registerJob(jobType, runJob)

function runJob(job: IJob) {
  jobLogger.assertJobType(job, jobType)

  let mc = jobLogger.assertMachine(job, (c) => c.data.type === 'reactor-em')

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.isFailed = false
    job.tasks = []
    let task = createFetchCargoTask(mc.i, mc.j, null, 'battery', false)
    job.tasks.push(task)

    task = createTask_deliverCargo(mc.i, mc.j, 'battery', true)
    job.tasks.push(task)

    task = createConsumeCargoTask(mc.i, mc.j, 'battery')
    job.tasks.push(task)

    task = createTask_custom(mc.i, mc.j, () => {
      mc.batterySupply = 100
      task.isComplete = true
    })
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
